import { render } from "./indexProductlist.vue?vue&type=template&id=14a59da3"
import script from "./indexProductlist.vue?vue&type=script&lang=js"
export * from "./indexProductlist.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__